const initialState = { code: "" };

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case "UPDATE_PENDING_CODE":
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
